import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthPage } from './pages/AuthPage';
import { DashboardPage } from './pages/DashboardPage';
import { UsersPage } from './pages/admin/UsersPage';
import { PartnerUploadPage } from './pages/admin/PartnerUploadPage';
import { AccountSearchPage } from './pages/AccountSearchPage';
import PartnerSuggestions from './pages/PartnerSuggestions';
import { AppLayout } from './components/layout/AppLayout';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { WorkerContextProvider } from './contexts/WorkerContext';
import './App.css';

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireAdmin?: boolean;
}

function ProtectedRoute({ children, requireAdmin = false }: ProtectedRouteProps) {
  const { user } = useAuth();
  
  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (requireAdmin && user.role !== 'ADMIN') {
    return <Navigate to="/dashboard" replace />;
  }

  return <AppLayout>{children}</AppLayout>;
}

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/auth" element={user ? <Navigate to="/dashboard" replace /> : <AuthPage />} />
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <DashboardPage />
        </ProtectedRoute>
      } />
      
      {/* Admin Routes */}
      <Route path="/admin/users" element={
        <ProtectedRoute requireAdmin>
          <UsersPage />
        </ProtectedRoute>
      } />
      <Route path="/admin/partners/upload" element={
        <ProtectedRoute requireAdmin>
          <PartnerUploadPage />
        </ProtectedRoute>
      } />
      <Route path="/partner-suggestions" element={
        <ProtectedRoute>
          <PartnerSuggestions />
        </ProtectedRoute>
      } />

      <Route path="/account-search" element={
        <ProtectedRoute>
          <AccountSearchPage />
        </ProtectedRoute>
      } />
      
      <Route path="*" element={<Navigate to={user ? "/dashboard" : "/auth"} replace />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <WorkerContextProvider>
          <AppRoutes />
        </WorkerContextProvider>
      </Router>
    </AuthProvider>
  );
}

export default App
